import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button, message } from 'antd';
import { useAssetActions } from '../../../../hooks/useAssets';
import { User } from '../../../../types/user.types';

const { Option } = Select;

interface CreateAssetModalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  employees?: User[]; // Optional çalışan listesi
  defaultUser?: User; // Default kullanıcı (employee details sayfasında kullanılır)
}

const CreateAssetModal: React.FC<CreateAssetModalProps> = ({
  visible,
  onClose,
  onSuccess,
  employees,
  defaultUser
}) => {
  const [form] = Form.useForm();
  const { createAsset, isLoading } = useAssetActions();

  useEffect(() => {
    if (visible) {
      form.resetFields();
      
      // Eğer defaultUser varsa, otomatik olarak seçili hale getir
      if (defaultUser) {
        form.setFieldsValue({
          userId: defaultUser.id
        });
      }
    }
  }, [visible, form, defaultUser]);

  const handleSubmit = async (values: any) => {
    try {
      await createAsset({
        name: values.name,
        serialNumber: values.serialNumber,
        userId: defaultUser ? defaultUser.id : values.userId
      });
      onSuccess();
      form.resetFields();
    } catch (error) {
      console.error('Create asset failed:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const showEmployeeSelection = employees && employees.length > 0 && !defaultUser;

  return (
    <Modal
      title="Yeni Zimmet Oluştur"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          name="name"
          label="Zimmet Adı"
          rules={[
            { required: true, message: 'Zimmet adı gereklidir' },
            { min: 2, message: 'Zimmet adı en az 2 karakter olmalıdır' },
            { max: 100, message: 'Zimmet adı en fazla 100 karakter olmalıdır' }
          ]}
        >
          <Input placeholder="Örn: Dell Latitude 7420 Laptop" />
        </Form.Item>

        <Form.Item
          name="serialNumber"
          label="Seri Numarası"
          rules={[
            { required: true, message: 'Seri numarası gereklidir' },
            { min: 3, message: 'Seri numarası en az 3 karakter olmalıdır' },
            { max: 50, message: 'Seri numarası en fazla 50 karakter olmalıdır' }
          ]}
        >
          <Input placeholder="Örn: D8KFG73" />
        </Form.Item>

        {/* Çalışan seçimi sadece employees prop'u varsa ve defaultUser yoksa göster */}
        {showEmployeeSelection && (
          <Form.Item
            name="userId"
            label="Çalışan"
            rules={[
              { required: true, message: 'Çalışan seçimi gereklidir' }
            ]}
          >
            <Select
              placeholder="Çalışan seçin"
              showSearch
              optionFilterProp="children"
            >
              {employees.map(employee => (
                <Option key={employee.id} value={employee.id}>
                  {employee.firstName} {employee.lastName} ({employee.email})
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {/* DefaultUser varsa bilgi mesajı göster */}
        {defaultUser && (
          <Form.Item label="Atanacak Çalışan">
            <div className="alert alert-info d-flex align-items-center">
              <i className="ti ti-info-circle me-2"></i>
              <span>
                Bu zimmet <strong>{defaultUser.firstName} {defaultUser.lastName}</strong> ({defaultUser.email}) 
                kullanıcısına atanacak
              </span>
            </div>
          </Form.Item>
        )}

        <Form.Item className="mb-0">
          <div className="d-flex justify-content-end gap-2">
            <Button onClick={handleCancel}>
              İptal
            </Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Oluştur
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateAssetModal; 